import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getdetailSalesOrder = () => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_D}` + `/get`);
};

export const billing_expense_getAlldetailSOById = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_D}` + `/getAllById/${id}`);
};

export const billing_expense_addDetailSO = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_D}`, data);
};

export const billing_expense_deletedetailSOById = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_D}` + `/${id}`);
};